/* Manilater product page: photos, size and length picker, Add to cart, phone bar, tabs and size chart. Needs assets/ml-home.js first. */
(() => {
  const root = document.querySelector('[data-mlp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));
  const buy = $('.mlp-buy');
  const p = JSON.parse(buy.querySelector(':scope > [data-mlh-product]').textContent);
  const nf = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
  const rupees = (cents) => '₹' + nf.format(Math.round(cents) / 100);
  const fit = (window.__mlhFit = window.__mlhFit || {});
  const optVals = (i) => [...new Set(p.variants.map((v) => v.o[i]))];
  // Nothing is pre-selected, except options with a single value
  const vals = p.options.map((n, i) => (optVals(i).length === 1 ? optVals(i)[0] : null));
  const groups = $$('[data-mlp-opt]');
  const atcs = $$('[data-mlp-atc]');
  const mainAtc = $('.mlp-buy [data-mlp-atc]');
  const msg = $('[data-mlp-msg]');
  const label = mainAtc ? mainAtc.textContent.trim() : 'Add to cart';
  const missing = () => vals.findIndex((v) => !v);
  const variant = () => p.variants.find((v) => v.o.every((o, i) => o === vals[i])) || null;

  function render() {
    $$('.mlp-opts [data-opt]').forEach((chip) => {
      const i = Number(chip.dataset.opt);
      const val = chip.dataset.value;
      chip.setAttribute('aria-pressed', String(vals[i] === val));
      const ok = p.variants.some((v) => v.a && v.o[i] === val && v.o.every((o, j) => j === i || !vals[j] || o === vals[j]));
      chip.classList.toggle('is-out', !ok);
    });
    const miss = missing();
    const v = miss < 0 ? variant() : null;
    let text = label;
    let disabled = false;
    if (miss >= 0) text = 'Choose your ' + p.options[miss].toLowerCase();
    else if (!v || !v.a) { text = 'Sold out in this size'; disabled = true; }
    else text = label + ' · ' + rupees(v.p);
    atcs.forEach((b) => {
      if (b.getAttribute('aria-busy') === 'true') return;
      b.textContent = b === mainAtc ? text : (miss >= 0 ? text : disabled ? 'Sold out' : label);
      b.disabled = disabled;
    });
    const price = rupees(v ? v.p : p.price);
    const priceEl = $('[data-mlp-price]');
    if (priceEl) priceEl.textContent = price;
    const barPrice = $('[data-mlp-bar-price]');
    if (barPrice) barPrice.textContent = price;
  }

  function flagMissing() {
    const miss = missing();
    if (miss < 0) return false;
    const g = groups.find((x) => Number(x.dataset.mlpOpt) === miss);
    msg.textContent = 'Please choose your ' + p.options[miss].toLowerCase() + '.';
    msg.hidden = false;
    if (g) {
      g.classList.remove('is-missing');
      void g.offsetWidth;
      g.classList.add('is-missing');
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return true;
  }

  async function add(btn) {
    if (flagMissing()) return;
    const v = variant();
    if (!v || !v.a || !window.__mlh) return;
    msg.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await window.__mlh.addLines([{ id: v.id, quantity: 1 }], btn);
    } catch (err) {
      msg.textContent = (err && err.message) || 'Could not add this set. Please try again.';
      msg.hidden = false;
    } finally {
      btn.removeAttribute('aria-busy');
      render();
    }
  }

  root.addEventListener('click', (e) => {
    const chip = e.target.closest('.mlp-opts [data-opt]');
    if (chip) {
      const i = Number(chip.dataset.opt);
      vals[i] = chip.dataset.value;
      fit[p.options[i]] = chip.dataset.value; // the size picker on the cards below starts with the same fit
      chip.closest('[data-mlp-opt]').classList.remove('is-missing');
      if (missing() < 0) msg.hidden = true;
      render();
      return;
    }
    const atc = e.target.closest('[data-mlp-atc]');
    if (atc) { add(atc); return; }
    const thumb = e.target.closest('[data-mlp-thumb]');
    if (thumb) {
      const slide = $(`[data-media-id="${thumb.dataset.mlpThumb}"]`);
      if (slide) slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    }
  });

  /* Photos: dots and thumbnails follow the swipe */
  const slides = $('[data-mlp-slides]');
  if (slides) {
    const dots = $$('.mlp-dots i');
    const thumbs = $$('[data-mlp-thumb]');
    let t = 0;
    slides.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
        thumbs.forEach((b, k) => b.classList.toggle('is-on', k === i));
      }, 60);
    }, { passive: true });
  }

  /* Tabs */
  const tabs = $$('[role="tab"]');
  const show = (tab, focus) => {
    tabs.forEach((x) => {
      const on = x === tab;
      x.setAttribute('aria-selected', String(on));
      x.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(x.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => show(tab));
    tab.addEventListener('keydown', (e) => {
      const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (step) { e.preventDefault(); show(tabs[(i + step + tabs.length) % tabs.length], true); }
    });
  });
  if (tabs.length) show(tabs.find((x) => x.getAttribute('aria-selected') === 'true') || tabs[0]);

  /* Size chart pop-up, also opened by "How sizing works" in the card size picker */
  const chart = $('[data-mlp-chart]');
  const openChart = () => {
    if (!chart) return;
    if (typeof chart.showModal === 'function') chart.showModal();
    else chart.setAttribute('open', '');
  };
  if (chart) {
    chart.addEventListener('click', (e) => {
      if (e.target === chart || e.target.closest('[data-close]')) {
        if (typeof chart.close === 'function') chart.close();
        else chart.removeAttribute('open');
      }
    });
    root.addEventListener('click', (e) => { if (e.target.closest('[data-mlp-chart-open]')) openChart(); });
    document.addEventListener('click', (e) => {
      if (e.target.closest('a[href="#mlh-sizing"]') && !document.getElementById('mlh-sizing')) {
        e.preventDefault();
        openChart();
      }
    });
  }

  /* How-to tabs in the How it works section below (sections/ml-product-story) */
  document.querySelectorAll('[data-mls-tabs]').forEach((group) => {
    const list = Array.from(group.querySelectorAll('[role="tab"]'));
    const pick = (tab, focus) => {
      list.forEach((x) => {
        const on = x === tab;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    list.forEach((tab, i) => {
      tab.addEventListener('click', () => pick(tab));
      tab.addEventListener('keydown', (e) => {
        const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (step) { e.preventDefault(); pick(list[(i + step + list.length) % list.length], true); }
      });
    });
  });

  /* Phone bar: shows once the main Add to cart button has scrolled above the screen */
  const bar = $('[data-mlp-bar]');
  if (bar && mainAtc) {
    let queued = false;
    const check = () => {
      queued = false;
      bar.hidden = mainAtc.getBoundingClientRect().bottom > 0;
    };
    window.addEventListener('scroll', () => {
      if (!queued) { queued = true; requestAnimationFrame(check); }
    }, { passive: true });
    check();
  }

  render();
})();
